import { render, staticRenderFns } from "./AuditorsTable.vue?vue&type=template&id=4d541e61"
import script from "./AuditorsTable.vue?vue&type=script&lang=js"
export * from "./AuditorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports